/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StatisticsSummaryGemData model module.
 * @module model/StatisticsSummaryGemData
 * @version 1.0
 */
class StatisticsSummaryGemData {
    /**
     * Constructs a new <code>StatisticsSummaryGemData</code>.
     * @alias module:model/StatisticsSummaryGemData
     */
    constructor() { 
        
        StatisticsSummaryGemData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StatisticsSummaryGemData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StatisticsSummaryGemData} obj Optional instance to populate.
     * @return {module:model/StatisticsSummaryGemData} The populated <code>StatisticsSummaryGemData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StatisticsSummaryGemData();

            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'Number');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>StatisticsSummaryGemData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StatisticsSummaryGemData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} type
 */
StatisticsSummaryGemData.prototype['type'] = undefined;

/**
 * @member {Number} count
 */
StatisticsSummaryGemData.prototype['count'] = undefined;






export default StatisticsSummaryGemData;

